var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
export var withoutOuiaProps = function (props) {
    var ouiaId = props.ouiaId, ouiaSafe = props.ouiaSafe, rest = __rest(props, ["ouiaId", "ouiaSafe"]);
    return rest;
};
export var makeOuiaAttributes = function (params) {
    var _a;
    var ouiaData = {
        'data-ouia-component-type': params.fullType,
        'data-ouia-safe': (_a = params.ouiaSafe) !== null && _a !== void 0 ? _a : true,
    };
    if (params.ouiaId) {
        ouiaData['data-ouia-component-id'] = params.ouiaId;
    }
    return ouiaData;
};
//# sourceMappingURL=Ouia.js.map